module.exports = __webpack_public_path__ + "img/SIKH LIME.1214375.svg";